import { Component, Input, OnDestroy } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import type { Entity } from '../../../core/models/entity.model';
import type { EntityType } from '../../../core/models/entity-type.model';
import { Store } from '@ngrx/store';
import { selectMultiEditProductEditorState } from '../../store/product-view/product-view.selectors';
import { FormGroup, UntypedFormGroup } from '@angular/forms';
import type { EntityEditorPropertyChangedEvent } from '../../../entity-editor/models/entity-editor-property-changed.event';
import { selectProjectId } from '../../store/project-data/project-data.selectors';
import { withLatestFrom } from 'rxjs/operators';
import { ProductViewActions } from '../../store/product-view/product-view.actions';

@Component({
  selector: 'app-multi-edit-product-editor',
  templateUrl: './multi-edit-product-editor.component.html',
  styleUrls: ['./multi-edit-product-editor.component.scss'],
  standalone: false
})
export class MultiEditProductEditorComponent implements OnDestroy {
  @Input() entityTypeNames: Record<string, string> | null;

  constructor(private store: Store) {
    this.multiEdit$ = store.select(selectMultiEditProductEditorState);
    this.updateSubject = new Subject<EntityEditorPropertyChangedEvent>();
    this.formGroup = new FormGroup({});

    this.updateSubscription = this.updateSubject
      .pipe(withLatestFrom(store.select(selectProjectId)))
      .subscribe(([propertyChange, projectId]) => {
        this.store.dispatch(ProductViewActions.multi_edit_entity_property_changed({ projectId, propertyChange }));
      });
  }

  protected multiEdit$: Observable<{ type: EntityType; combinedEntity: Entity; selectedEntitiesCount: number }>;
  protected formGroup: UntypedFormGroup;

  private updateSubject: Subject<EntityEditorPropertyChangedEvent>;
  private updateSubscription: Subscription;

  protected propertyChanged(change: EntityEditorPropertyChangedEvent): void {
    this.updateSubject.next(change);
  }

  ngOnDestroy(): void {
    this.updateSubscription?.unsubscribe();
  }
}
